<template>
  <b-container v-if="this.type" fluid>
    <h1 v-if="title !== false">
      {{title || $appConfig.models[this.type].title}}
      <b-button v-if="$appConfig.models[this.type].allowNew === true && !$appConfig.models[this.type].shared || $appConfig.models[this.type].shared && isSuperAdmin" variant="secondary" size="sm" :to="'/new/' + type" v-translate>+ NEW</b-button>
      <b-button v-if="$appConfig.models[this.type].allowBulk" variant="secondary" size="sm" :to="'/bulk/' + type" v-translate>Manage Bulk</b-button>
      <b-button v-if="type === 'companies' && (isAdmin || isAccountant)" variant="primary" size="sm" @click.prevent="generateReport" v-translate>
        Generate Report
      </b-button>
      <b-button @click.prevent="downloadCsv" v-if="$appConfig.models[this.type].asyncCsvReport" v-translate>Download CSV Report</b-button>
    </h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0; deleted = false"
      @dismiss-count-down="countDownChanged"
    >
      <span v-if="!deleted" v-translate>
        The Item has been created
      </span>
      <span v-else v-translate>
        The Item has been deleted
      </span>
    </b-alert>
    <b-card no-body class="filters">
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('Quick Filters')" active>
          <b-card-text>
            <b-row>
              <b-col class="text-center filter-actions">
                <b-badge size="md" @click="resetQuickFilters" v-translate>Reset Filters</b-badge> <b-badge size="sm" @click="saveCurrentQuickFilters" v-translate>Save this Filters' Set</b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="1" md="3">
                <b-form-group>
                  <label for="filter-statuses" v-translate>Statuses</label>
                  <b-form-checkbox-group stacked id="filter-statuses" v-model="filter.statuses" :options="fleetRentalOrderStatuses"></b-form-checkbox-group>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox id="filter-expireds" v-model="filter.expireds"><translate>Still open but expired</translate></b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <div class="form-group">
                  <label for="filter-reference" v-translate>Reference</label>
                  <input id="filter-reference" v-model.lazy="filter.reference" type="text" class="mb-2 col-12 form-control">
                </div>
                <b-form-group>
                  <label for="filter-company" v-translate>Company</label>
                  <company-autocomplete ref="companyAc" @selected="onSearchCompanySelected" />
                  <b-badge v-for="(item, index) in filter.company" :key="index">
                    {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCompanyFromFilters(index)">×</b-badge>
                  </b-badge>&nbsp;
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group v-if="$store.getters.profile.roles.findIndex(x => x.name === this.$roles.INTERNATIONAL) !== -1 && $cookies.get('bypassCountry')">
                  <label for="filter-name" v-translate>Country</label>
                  <b-form-select v-model="filter.country" :options="this.countries.map(x => { return {value: x.iso_code, text: x.name} })">
                    <template #first>
                      <option :value="null"><translate>Select Country</translate></option>
                    </template>
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <label for="region" v-translate>Region</label>
                  <b-input-group>
                    <b-form-select v-if="regionsSelect" v-model="filter.region" :options="regionsSelect">
                      <template #first>
                        <option :value="null"><translate>All</translate></option>
                      </template>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <label class="" for="inline-form-input-name" v-translate>In Date Range</label><label v-show="filter.inDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="fullResetInDateRange" v-translate>reset range</a>]</label>
                  <date-range-picker
                    v-model="inDateRange"
                    @update="filter.inDateRangeActive++"
                    :locale-data="locale"
                    :opens="opens"
                    class="mb-2 w-100"
                    :ranges="ranges"
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span v-if="filter.inDateRangeActive === 0" style="vertical-align: middle">...</span>
                      <span v-else style="vertical-align: middle">{{moment(inDateRange.startDate).format('L')}} - {{moment(inDateRange.endDate).format('L')}}</span>
                    </div>
                  </date-range-picker>
                </b-form-group>
              </b-col>
              <b-col>

              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Advanced Filters')">
          <b-card-text>
            <b-row>
              <b-col lg="12" class="my-1">
                <listing-filter :type="type" @save-filter="saveCurrentAdvancedFilters" :filter-fields="filterFields" :pre-filters="preFilters" @refresh="refreshTable" ref="listingFilters" />
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Saved Filters')" :disabled="savedFleetRentalQuickSearches.length === 0">
          <b-list-group>
            <b-list-group-item v-for="(savedQuickSearch, index) in savedFleetRentalQuickSearches" :key="index" :href="savedQuickSearch.url" class="d-flex justify-content-between align-items-center">
              {{ savedQuickSearch.name }}
              <b-badge href="#" @click.stop.prevent="deleteSavedQuickSearch(index)" variant="danger">✕</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row>
      <b-col md="8" class="my-1">
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group horizontal :label="$gettext('Per page')" :label-cols="9" class="text-right mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" @change="onFiltered" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="bg-white py-1" v-translate="{totalRows: totalRows || '-'}">
        Total items: <strong>%{totalRows}</strong>
      </b-col>
    </b-row>
    <b-table id="apiListTable" stacked="md" foot-clone :total-rows="totalRows" :sort-desc="sortDesc" :sort-by="sortBy" :per-page="perPage" :current-page="currentPage" :busy.sync="isBusy" :items="myProvider" :fields="fields" :api-url="this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint" :filter="applyFilter">

      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>

      <template #cell()="data">
        <div v-if="fields.find(x => x.key === data.field.key).filter" v-html="$options.filters[fields.find(x => x.key === data.field.key).filter](data.value)"></div>
        <div v-else-if="fields.find(x => x.key === data.field.key).formatter" v-html="data.value"></div>
        <div v-else-if="fields.find(x => x.key === data.field.key).options && fields.find(x => x.key === data.field.key).include && fields.find(x => x.key === data.field.key).showField">{{fields.find(x => x.key === data.field.key).include.find(x => x[fields.find(x => x.key === data.field.key).showKey || 'id'] === data.value)[fields.find(x => x.key === data.field.key).showField]}}</div>
        <div v-else>{{data.value}}</div>
      </template>

      <template v-slot:cell(id)="data">
        <div v-if="$appConfig.models[type].noIdLink || (!$appConfig.models[type].noIdLink && $appConfig.models[type].shared === true && !isMoova) || (!$appConfig.models[type].noIdLink && $appConfig.models[type].shared === 'semi' && !isSuperAdmin)">
          {{data.value | uuid}}
        </div>
        <div v-else>
          <a :href="'/edit/' + type + '/' + data.value">
            {{data.value | uuid}}
          </a>
          <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')">
            <font-awesome-icon :icon="['far', 'copy']" size="1x" />
          </a>
        </div>
      </template>

      <template v-slot:cell(name)="data">
        <span :class="data.item.is_dangerous ? 'text-danger' : ''">{{data.value}}</span>
      </template>

      <template v-slot:cell(is_dangerous)="data">
        <span v-if="data.value" class="text-danger" v-translate>YES</span>
        <span v-else v-translate>NO</span>
      </template>

      <template v-slot:cell(from_contact)="row">
        <strong>{{row.item.from_contact}}</strong><br>
        <span v-if="row.item.from_phone"><a :href="'tel:' + row.item.from_phone">{{row.item.from_phone}}</a><br></span>
        <span v-if="row.item.from_email">{{row.item.from_email}}</span>
      </template>

      <template v-slot:cell(to_contact)="row">
        <strong>{{row.item.to_contact}}</strong><br>
        <span v-if="row.item.to_phone"><a :href="'tel:' + row.item.to_phone">{{row.item.to_phone}}</a><br></span>
        <span v-if="row.item.to_email">{{row.item.to_email}}</span>
      </template>

      <template v-slot:cell(from_address)="row">
        <span v-if="(!row.item.fields_revision || row.item.fields_revision === false) || !row.item.fields_revision_data.from || typeof row.item.fields_revision_data.from === 'object'">
          <span
            class="shipping-address-listings"
            :class="row.item.fields_revision_data &&
              row.item.fields_revision_data.from &&
              typeof row.item.fields_revision_data.from === 'object' ? 'text-warning' : ''"
            :title="row.item.address_from.formatted_address"><font-awesome-icon v-if="row.item.fields_revision_data &&
              row.item.fields_revision_data.from &&
              typeof row.item.fields_revision_data.from === 'object'" icon="exclamation-triangle" size="1x" /> {{row.item.address_from.formatted_address}}</span>
        </span>
        <span v-if="row.item.fields_revision_data !== null && typeof row.item.fields_revision_data.from === 'string'">
          <span
            class="shipping-address-listings text-danger"
            :title="row.item.fields_revision_data.from"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{row.item.fields_revision_data.from}}</span>
        </span>
        <span class="shipping-address-listings" style="display: block;" :title="row.item.from_meta" v-if="row.item.from_meta"><br>{{row.item.from_meta}}</span>
      </template>

      <template v-slot:cell(to_address)="row">
        <span v-if="(!row.item.fields_revision || row.item.fields_revision === false) || !row.item.fields_revision_data.to || typeof row.item.fields_revision_data.to === 'object'">
          <span
            class="shipping-address-listings"
            :class="row.item.fields_revision_data &&
              row.item.fields_revision_data.to &&
              typeof row.item.fields_revision_data.to === 'object' ? 'text-warning' : ''"
            :title="row.item.address_to.formatted_address"><font-awesome-icon v-if="row.item.fields_revision_data &&
              row.item.fields_revision_data.to &&
              typeof row.item.fields_revision_data.to === 'object'" icon="exclamation-triangle" size="1x" /> {{row.item.address_to.formatted_address}}</span>
        </span>
        <span v-if="row.item.fields_revision_data !== null && typeof row.item.fields_revision_data.to === 'string'">
          <span class="shipping-address-listings text-danger" :title="row.item.fields_revision_data.to"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{row.item.fields_revision_data.to}}</span>
        </span>
        <span class="shipping-address-listings" style="display: block;" :title="row.item.to_meta" v-if="row.item.to_meta">{{row.item.to_meta}}</span>
      </template>

      <template v-slot:cell(scheduled_date)="row">
        <div v-if="row.item.scheduled_date">
          {{moment.utc(row.item.scheduled_date).tz($tz).format('YYYY-MM-DD')}}<br>
          {{moment.utc(row.item.scheduled_date).tz($tz).format('HH:mm:ss')}}
        </div>
      </template>

      <template v-slot:cell(updated_at)="row">
        {{moment.utc(row.item.updated_at).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.updated_at).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(created_at)="row">
        {{moment.utc(row.item.created_at).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.created_at).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(date_from)="row">
        {{moment.utc(row.item.date_from).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.date_from).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(date_to)="row">
        {{moment.utc(row.item.date_to).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.date_to).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(tags)="row">
        <div v-if="row.item.tags.length > 0" style="width: 220px;">
          <span v-for="(item, index) in row.item.tags" :key="index">
            <b-badge pill variant="danger">{{ item.name }}</b-badge>&nbsp;
          </span>
        </div>
      </template>

      <template v-slot:cell(courier)="row">
        <div v-if="row.item.courier">
          <user-card :user='row.item.courier' :profile-picture="false" :with-titles="false" :vehicle-types-prop="vehicleTypes" />
        </div>
      </template>

      <template v-slot:cell(phone)="row">
        {{row.item.phone | phone(row.item.country_iso_code || 'ar')}}
      </template>

      <template v-slot:cell(amount_requested)="row">
        <strong :class="'text-' + (row.item.fleet_rental_order_vehicles.length === 0 ? 'danger' : (row.item.fleet_rental_order_vehicles.length < row.value ? 'warning' : 'success'))">{{row.item.fleet_rental_order_vehicles.length}}/{{row.value}}</strong><br>
        <b-button size="sm" class="p-0 px-1" :variant="!row.item.meta || !row.item.meta.serviceDefinition ? 'dark' : (row.item.fleet_rental_order_vehicles.reduce((n, {meta}) => { return n + (meta && meta.serviceDetail && meta.serviceDetail.quantity ? parseInt(meta.serviceDetail.quantity) : 0) }, 0) === 0 ? 'danger' : (row.item.fleet_rental_order_vehicles.reduce((n, {meta}) => { return n + (meta && meta.serviceDetail && meta.serviceDetail.quantity ? parseInt(meta.serviceDetail.quantity) : 0) }, 0) < row.item.meta.serviceDefinition.quantity ? 'warning' : 'success'))" :id="'tooltip-target-' + row.index">
          <small>
            <font-awesome-icon :icon="['far', 'eye']" />
            <span v-translate>Service Details</span>
          </small>
        </b-button>
        <b-tooltip :target="'tooltip-target-' + row.index" triggers="hover">
          <div style="min-width: 250px" class="text-left">
            <dl v-if="row.item.meta && row.item.meta.serviceDefinition">
              <dt v-translate>Service Type</dt>
              <dd>{{ unitTypes.find(x => x.value === row.item.meta.serviceDefinition.unitType).text || $gettext('Generic') }}</dd>
              <dt v-translate>Service Quantity/Assigned</dt>
              <dd>{{ row.item.fleet_rental_order_vehicles.reduce((n, {meta}) => { return n + (meta && meta.serviceDetail && meta.serviceDetail.quantity ? parseInt(meta.serviceDetail.quantity) : 0) }, 0) }}/{{ row.item.meta.serviceDefinition.quantity }}</dd>
            </dl>
            <p class="mb-0" v-else v-translate>Service Details not defined</p>
          </div>
        </b-tooltip>
      </template>

      <template #cell(status)="row">
        <div :class="'text-' + fleetRentalOrderStatuses.find(x => x.value === row.item.status).variant">
          {{ fleetRentalOrderStatuses.find(x => x.value === row.item.status).text }}
        </div>
      </template>

      <template v-slot:cell(instructions)="row">
        <div v-html="$options.filters.brize(row.value)"></div>
      </template>

      <template v-slot:cell(actions)="row">
        <span v-if="$appConfig.models[type].extraActions && (!action.position || action.position !== 'end')" v-for="(action, index) in $appConfig.models[type].extraActions" :key="index">
          <b-button
            :size="action.size || 'sm'"
            :variant="action.variant || 'primary'"
            @click="action.action(row.item, that)"
            :title="action.title || ''"
            style="padding: .5rem .65rem"
            class="mb-1"
            :disabled="(action.disabledCondition && action.disabledCondition(row.item))"
          >
            <font-awesome-icon v-if="action.icon" :icon="action.icon" size="2x" style="font-size: 16px;vertical-align: middle" />
            <span v-else>{{action.label}}</span>
          </b-button>
        </span>
        <b-button size="sm" variant="primary" @click.stop="editingRow = JSON.parse(JSON.stringify(row))" v-b-modal.modalEditInPlace style="padding: .5rem .6rem" class="mb-1" v-if="editInPlace">
          <font-awesome-icon icon="edit" size="2x" style="font-size: 16px;vertical-align: middle" />
        </b-button>
        <b-button size="sm" @click.stop="row.toggleDetails" style="padding: .5rem" class="mb-1">
          <font-awesome-icon v-if="row.detailsShowing" :icon="['far', 'eye-slash']" size="2x" style="font-size: 16px;vertical-align: middle" />
          <font-awesome-icon v-else :icon="['far', 'eye']" size="2x" style="font-size: 16px;vertical-align: middle" />
        </b-button>
        <b-button size="sm" variant="danger" @click.stop="deleteRow(row.item.id)" style="padding: .5rem .63rem" class="mb-1" v-if="allowDelete && !$appConfig.models[type].shared || (allowDelete && $appConfig.models[type].shared && isSuperAdmin)">
          <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
        </b-button>
        <span v-if="$appConfig.models[type].extraActions && action.position === 'end'" v-for="(action, index) in $appConfig.models[type].extraActions" :key="index" class="d-inline-block">
          <b-button
            :size="action.size || 'sm'"
            :variant="action.variant || 'primary'"
            @click="action.action(row.item)"
            :title="action.title || ''"
            style="padding: .5rem .65rem"
            class="mb-1"
            :disabled="(action.disabledCondition && action.disabledCondition(row.item))"
          >
            <font-awesome-icon v-if="action.icon" :icon="action.icon" size="2x" style="font-size: 16px;vertical-align: middle" />
            <span v-else>{{action.label}}</span>
          </b-button>&nbsp;
        </span>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key" v-if="value && value.length !== 0 && value !== 'undefined' && value !== null">{{ key }}: <span v-html="key.indexOf('phone') === -1 ? isJson(value) : value.toString()"></span></li>
          </ul>
        </b-card>
      </template>

    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" v-if="totalRows > perPage" class="my-0" />

    <b-modal id="modalEditInPlace" ref="modalEditInPlace" hide-footer>
      <div slot="modal-title" v-translate="{type: $appConfig.models[this.type].title}">Edit %{type}</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <api-item-edit :id="editingRow.item.id" :type="this.type" :static-item="editingRow" v-if="editingRow.item" @success="updateInPlace" />
    </b-modal>

  </b-container>
</template>

<script>
function initialQuickFilters() {
  return {
    reference: '',
    company: [],
    statuses: [],
    expireds: false,
    country: null,
    region: null,
    inDateRangeActive: 0
  }
}
import ListingFilter from '@/components/ListingFilter'
import UserCard from '@/components/UserCard'
import ApiItemEdit from '@/components/ApiItemEdit'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import DateRangePicker from 'vue2-daterange-picker'

export default {
  name: 'FleetRentalOrderList',
  components: {
    ListingFilter,
    UserCard,
    ApiItemEdit,
    CompanyAutocomplete,
    DateRangePicker
  },
  props: {
    type: {
      type: String,
      default: 'fleet-rental-orders'
    },
    title: {
      type: [String, Boolean],
      default: null
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 25
    },
    staticItems: {
      type: Array,
      default: null
    },
    noActions: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tabIndex: 0,
      fields: [],
      filterFields: this.$appConfig.models[this.type].filters,
      exclude: this.$appConfig.models[this.type].exclude,
      includes: this.$appConfig.models[this.type].includes || [],
      allowDelete: this.$appConfig.models[this.type].allowDelete,
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [ 10, 25, 50, 100, 500 ],
      sortBy: 'updated_at',
      sortDesc: true,
      sortDirection: 'desc',
      filters: this.preFilters,
      filter: initialQuickFilters(),
      quickFilters: {},
      inDateRange: { // used for v-model prop
        startDate: this.moment().subtract(6, 'day').startOf('day').toDate(),
        endDate: this.moment().subtract(0, 'day').endOf('day').toDate()
      },
      opens: 'right', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      },
      ranges: { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 120 days')]: [this.moment().subtract(120, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        // [this.$gettext('This year')]: [this.moment().startOf('year'), this.moment().endOf('year')],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      },
      inDateRangeActive: 0,
      savedFleetRentalQuickSearches: [],
      dismissSecs: 5,
      dismissCountDown: 0,
      deleted: false,
      editingRow: {},
      csvUrl: {},
      fleetRentalOrderStatuses: [
        {
          text: this.$gettext('Pending'),
          value: 'pending',
          variant: 'info'
        },
        {
          text: this.$gettext('Assigned'),
          value: 'assigned',
          variant: 'warning'
        },
        {
          text: this.$gettext('Confirmed'),
          value: 'confirmed',
          variant: 'success'
        },
        {
          text: this.$gettext('Incidence'),
          value: 'incidence',
          variant: 'warning'
        },
        {
          text: this.$gettext('Finished'),
          value: 'finished',
          variant: 'success'
        },
        {
          text: this.$gettext('Cancelled'),
          value: 'canceled',
          variant: 'danger'
        }
      ],
      unitTypes: [
        {
          text: this.$gettext('Generic'),
          value: 'generic'
        },
        {
          text: this.$gettext('Weight (Tons)'),
          value: 'weightTons'
        },
        {
          text: this.$gettext('Weight (Kgs)'),
          value: 'weightKgs'
        },
        {
          text: this.$gettext('Guides'),
          value: 'guides'
        },
        {
          text: this.$gettext('Routes'),
          value: 'routes'
        }
      ],
      that: null
    }
  },
  computed: {
    applyFilter() {
      return this.filter
    },
    editInPlace() {
      return this.$appConfig.models[this.type].editInPlace || false
    }
  },
  watch: {
    type: async function (val) {
      this.resetData()
      this.$refs.listingFilters.resetData()
      this.fields = this.$appConfig.models[this.type].fields
      this.filterFields = this.$appConfig.models[this.type].filters
      this.exclude = this.$appConfig.models[this.type].exclude
      this.fields.push({ key: 'actions', label: this.$gettext('Actions') })
      let that = this
      this.fields = this.fields.filter(function (obj) {
        if (that.exclude) {
          return that.exclude.indexOf(obj.key) === -1
        } else {
          return true
        }
      })
      for (let field of this.fields) {
        if (field.options && !Array.isArray(field.options)) {
          await this['fetch' + field.options.charAt(0).toUpperCase() + field.options.slice(1)]()
          field.include = this[field.options]
          // field.includeSelect = this[field.options + 'Select']
        }
      }
      this.refreshTable()
    },
    exclude: function (val) {
      return this.$appConfig.models[this.type].exclude
    },
    'filter.statuses': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['statuses'] = [ 'status', 'in', val ]
        } else {
          this.quickFilters['statuses'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.reference': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['reference'] = [ 'reference', 'ct', val ]
        } else {
          this.quickFilters['reference'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.company': {
      handler (val) {
        if (val.length > 0) {
          let companies = val.map(function (item) {
            return item.id
          })
          let companyNames = val.map(function (item) {
            return item.name
          })
          this.quickFilters['company'] = [[ 'company_id', 'in', companies ], companyNames]
        } else {
          this.quickFilters['company'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.expireds': {
      handler (val) {
        if (val) {
          this.quickFilters['expireds'] = {
            filters: [
              ['status', 'in', ['pending', 'assigned', 'confirmed', 'incidence']],
              ['date_to', 'lt', this.moment.utc().format('YYYY-MM-DD HH:mm:ss')]
            ]
          }
        } else {
          this.quickFilters['expireds'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.country': {
      handler (val) {
        if (val) {
          this.quickFilters['country'] = [ 'company.country_iso_code', 'eq', val ]
        } else {
          this.quickFilters['country'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.region': {
      handler (val) {
        if (val) {
          this.quickFilters['region'] = [ 'region_id', 'eq', val ]
        } else {
          this.quickFilters['region'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.inDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          this.quickFilters['inRangeFrom'] = ['date_from', 'gte', this.inDateRange.startDate.length === 19 ? this.moment(this.inDateRange.startDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.inDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['inRangeTo'] = ['date_to', 'lte', this.inDateRange.endDate.length === 19 ? this.moment(this.inDateRange.endDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.inDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
        } else {
          this.quickFilters['inRangeFrom'] = []
          this.quickFilters['inRangeTo'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    }
  },
  created() {
    this.fetchCountries()
    this.fetchRegions()
  },
  async mounted() {
    this.resetData()
    if (this.$route.query.created === true) {
      this.showAlert()
    }
    if (this.$route.query.deleted === true) {
      this.deleted = true
      this.showAlert()
    }
    this.fields = this.$appConfig.models[this.type].fields
    this.includes = this.$appConfig.models[this.type].includes
    this.exclude = this.$appConfig.models[this.type].exclude
    let that = this
    let fields = this.fields.filter(function (obj) {
      if (that.exclude) {
        return that.exclude.indexOf(obj.key) === -1
      } else {
        return true
      }
    })
    fields.push({ key: 'actions', label: this.$gettext('Actions') })
    if (this.noActions || this.$appConfig.models[this.type].noActions) {
      fields.pop()
    }
    this.fields = fields
    if (this.$route.query.s) {
      this.tabIndex = 1
      this.checkAdvancedFilters()
    } else if (this.$route.query.qs) {
      this.checkQuickFilters()
    } else {
      this.refreshTable(initialQuickFilters())
    }
    if (localStorage.savedQuickSearches) {
      this.savedQuickSearches = JSON.parse(localStorage.savedQuickSearches)
    }
    this.that = this
  },
  methods: {
    checkQuickFilters() {
      this.advancedFilters = []
      this.$refs.listingFilters.resetData()
      if (this.$route.query.qs) {
        this.quickFilters = JSON.parse(this.$route.query.qs)
        Object.keys(JSON.parse(this.$route.query.qs)).forEach(function (key) {
          // Multi Filters
          if (this.quickFilters[key].filters) {
            this.filter[key] = this.quickFilters[key].filters[0][2]
          } else if (this.quickFilters[key].length > 2 && key !== 'sla') {
            if (key === 'withoutTour') {
              if (this.quickFilters[key].length === 4) {
                this.filter[key] = 'false'
                return
              }
            }
            if (key === 'inRangeFrom') {
              this.inDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'inRangeTo') {
              this.inDateRange.endDate = this.quickFilters[key][2]
              this.filter.inDateRangeActive = true
            }
            if (key === 'createdAtFrom') {
              this.createdDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'createdAtTo') {
              this.createdDateRange.endDate = this.quickFilters[key][2]
              this.filter.createdDateRangeActive = true
            }
            this.filter[key] = this.quickFilters[key][2]
          } else if (this.quickFilters[key].length === 2 && key !== 'sla') {
            this.filter[key] = []
            for (let i = 0; i < this.quickFilters[key][0][2].length; i++) {
              this.filter[key].push({id: this.quickFilters[key][0][2][i], name: this.quickFilters[key][1][i], email: this.quickFilters[key][1][i]})
            }
          }
          if (key === 'sla') {
            this.filter.sla = this.quickFilters[key]
          }
          if (this.quickFilters.statuses && this.quickFilters.statuses.length > 0 && this.quickFilters.statuses[2].indexOf('READY') === -1 && this.quickFilters.statuses[2].indexOf('WAITING') === -1) {
            this.filter.withoutTour = 'indeterminate'
          }
        }.bind(this))
        this.updateQuickFilters()
      }
    },
    updateQuickFilters() {
      if (this.tabIndex === 0) {
        this.currentPage = 1
        let filters = []
        Object.values(this.quickFilters).forEach(function (filter) {
          if (filter.length === 2) {
            filters.push(filter[0])
          } else {
            filters.push(filter)
          }
        })
        if (filters.length > 0) {
          this.$router.push({ query: {qs: JSON.stringify(this.quickFilters)} })
        }
        this.refreshTable(filters)
      }
    },
    resetQuickFilters: function () {
      Object.assign(this.$data.filter, initialQuickFilters())
      this.updateQuickFilters()
    },
    saveCurrentQuickFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedFleetRentalQuickSearches.push({name: 'QUICK: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedFleetRentalQuickSearches = JSON.stringify(this.savedFleetRentalQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedFleetRentalQuickSearches = JSON.parse(localStorage.savedFleetRentalQuickSearches)
    },
    resetAdvancedFilters: function () {
      this.$refs.listingFilters.resetData()
      this.$refs.listingFilters.emitRefresh()
    },
    saveCurrentAdvancedFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedFleetRentalQuickSearches.push({name: 'ADVANCED: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedFleetRentalQuickSearches = JSON.stringify(this.savedFleetRentalQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedFleetRentalQuickSearches = JSON.parse(localStorage.savedFleetRentalQuickSearches)
    },
    deleteSavedQuickSearch(index) {
      this.savedFleetRentalQuickSearches.splice(index, 1)
      localStorage.savedFleetRentalQuickSearches = JSON.stringify(this.savedFleetRentalQuickSearches)
      this.savedFleetRentalQuickSearches = JSON.parse(localStorage.savedFleetRentalQuickSearches)
    },
    fullResetInDateRange() {
      this.updatedDateRange = {
        startDate: this.moment().subtract(6, 'day').startOf('day').toDate(),
        endDate: this.moment().subtract(0, 'day').endOf('day').toDate()
      }
      this.filter.inDateRangeActive = 0
    },
    myProvider (ctx) {
      if (!this.staticItems) {
        console.log(ctx)
        let params = {
          page: ctx.currentPage - 1,
          limit: ctx.perPage,
          includes: this.includes,
          sort: [
            {
              key: ctx.sortBy || 'id',
              direction: ctx.sortDesc ? 'desc' : 'asc'
            }
          ],
          filter_groups: []
        }
        console.log(this.filters)
        if (this.filters || this.preFilters) {
          let singleFilters = [...new Set(this.filters)].filter(filter => typeof filter === 'object' && !filter.filters && !filter.filterGroups && ['tomorrow', 'future', 'on-time', 'expired'].indexOf(filter[0]) === -1)
          let multiFilters = [...new Set(this.filters)].filter(filter => typeof filter === 'object' && filter.filters)
          let multiFilterGroups = [...new Set(this.filters)].filter(filter => typeof filter === 'object' && filter.filterGroups)

          if (singleFilters.length > 0) {
            params.filter_groups.push(
              {
                filters: singleFilters || this.preFilters
              }
            )
          }
          if (multiFilters.length > 0) {
            for (const multiFilter of multiFilters) {
              params.filter_groups.push(multiFilter)
            }
          }
          if (multiFilterGroups.length > 0) {
            for (const multiFilterGroup of multiFilterGroups) {
              for (const filterGroup of multiFilterGroup.filterGroups) {
                params.filter_groups.push(filterGroup)
              }
            }
          }
        }
        console.log(JSON.stringify(params))

        if (!this.$cookies.get('bypassCountry') && this.$appConfig.models[this.type].countrize) {
          params.filter_groups.push(
            {
              filters: [
                [this.$appConfig.models[this.type].countrize, 'eq', window.country]
              ]
            }
          )
        }
        if (!this.$cookies.get('bypassCountry') && this.$appConfig.models[this.type].countrizeById) {
          params.filter_groups.push(
            {
              filters: [
                [this.$appConfig.models[this.type].countrizeById, 'eq', window.countries.find(x => x.iso_code === window.country).id]
              ]
            }
          )
        }

        let csvParams = {...params}
        csvParams.format = 'csv'

        this.csvUrl = {
          url: ctx.apiUrl,
          params: csvParams
        }

        let promise = this.$http.get(ctx.apiUrl, { params: params })

        return promise.then((data) => {
          const items = data.body.data
          // // Here we could override the busy state, setting isBusy to false
          // // this.isBusy = false
          this.totalRows = data.body.pagination.total
          this.$emit('itemsLoaded', items)
          this.$emit('totalRows', this.totalRows)
          return (items)
        }).catch(error => {
          console.log(error)
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return []
        })
      } else {
        let promise = Promise.resolve(this.staticItems)
        this.totalRows = this.staticItems.length
        this.$emit('itemsLoaded', this.staticItems)
        this.$emit('totalRows', this.totalRows)
        return promise.then(data => {
          return data
        })
      }
    },
    refreshTable (filters) {
      console.log(filters)
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', 'apiListTable')
      }, 100)
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
      console.log(filteredItems.length)
      this.refreshTable(this.filters)
    },
    deleteRow(id) {
      if (
        confirm(this.$gettextInterpolate(this.$gettext('Are you sure you want to DELETE the row with ID:\n%{id}\nWARNING: THIS ACTION CANNOT BE UNDONE!'), {id: id}))
      ) {
        let endpoint = this.$appConfig.models[this.type].endpointDelete ? this.$appConfig.models[this.type].endpointDelete.replace('{id}', id) : this.$appConfig.models[this.type].endpoint + '/' + id
        this.$http.delete(this.$appConfig.api.baseUrl + endpoint)
          .then(response => {
            this.refreshTable(this.filters)
          })
      }
    },
    updateInPlace(data) {
      if (!this.staticItems) {
        this.refreshTable(this.filters)
      } else {
        this.staticItems[data.index] = data.item
        this.editingRow = {}
        this.refreshTable(this.filters)
      }
      if (this.$appConfig.models[this.type].editInPlace) {
        this.$refs.modalEditInPlace.hide()
      }
    },
    downloadCsv() {
      let data = {
        url: this.csvUrl.url,
        params: this.csvUrl.params,
        type: 'text/csv;charset=utf-8;',
        filename: this.moment().local().format('YYYY-MM-DD_HH-mm') + '__' + this.type + '_export'
      }
      this.downloadAsync(data)
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    onSearchCompanySelected(item) {
      this.filter.company.push({id: item.id, name: item.name})
      this.$refs.companyAc.searchQuery = ''
    },
    removeCompanyFromFilters(index) {
      this.filter.company.splice(index, 1)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
